<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Quill from "quill";
window.Quill = Quill
console.log('Quill fire!');

import { quillEditor } from "vue-quill-editor";
var Parchment = Quill.import('parchment');

var Font = Quill.import("formats/font");

// Font.whitelist = ["abel", "abrilfatface", "acme", "amaticsc", "anticslab", "anton", "architectsdaughter", "archivonarrow", "arimo", "arvo", "asap", "assistant", "balsamiqsans", "barlow", "barlowcondensed", "bebasneue", "bitter", "breeserif", "cabin", "cairo", "catamaran", "comfortaa", "cormorantgaramond", "crimsontext", "dancingscript", "domine", "dosis", "ebgaramond", "exo", "exo2", "firasans", "fjallaone", "fredokaone", "heebo", "hind", "hindmadurai", "hindsiliguri", "ibmplexsans", "ibmplexserif", "inconsolata", "indieflower", "inter", "josefinsans", "kanit", "karla", "lato", "librebaskerville", "librefranklin", "lobster", "lora", "martel", "mavenpro", "merriweather", "merriweathersans", "monda", "montserrat", "mukta", "nanumgothic", "notosans", "notosanshk", "notosansjp", "notosanskr", "notosanssc", "notosanstc", "notoserif", "nunito", "nunitosans", "opensans", "oswald", "overpass", "oxygen", "pacifico", "patrickhand", "playfairdisplay", "poppins", "prompt", "ptsans", "ptsansnarrow", "ptserif", "questrial", "quicksand", "raleway", "roboto", "robotocondensed", "robotomono", "robotoslab", "rubik", "shadowsintolight", "signika", "slabo27px", "sourcecodepro", "sourcesanspro", "sourceserifpro", "teko", "titilliumweb", "ubuntu", "varelaround", "worksans", "yanonekaffeesatz", "zillaslab"];
Font.whitelist = ["arial", "arialblack", "comicsans", "courier", "couriernew", "droidsans", "georgia", "helvetica", "lucidasans",
	"opensans", "roboto", "tahoma", "timesnewroman", "trebuchetms", "verdana","brushscriptmt"];

Quill.register(Font, true);

// --------------------

var SizeStyle = Quill.import("attributors/style/size");
SizeStyle.whitelist = null;
// [
// 	"6px", "8px", "10px", "12px", "14px", "16px", "18px", "21px", "24px", "28px", "32px", "36px", "42px", "48px", "56px", "64px", "72px", "80px", "88px", "96px", "104px", "120px", "144px",
// ];
window.whitelist = SizeStyle.whitelist;
Quill.register(SizeStyle, true);

// --------------------

let Link = Quill.import('formats/link');
Link.sanitize = function(url) {
	// modify url if desired
	if (url && !url.startsWith('http://') && !url.startsWith('https://'))
		url = 'https://' + url;
	return url;
}

// custom Dynamic Value placeholder format
var Embed = Quill.import('blots/embed');
class QuillDValue extends Embed {
	static create(value) {
		let node = super.create(value);
		// var beforeSep = value.split('|')[0];
		// var afterSep = value.split('|')[1];

		node.innerHTML = `${value}`;
		return node;
	}
	static value(domNode) {
		return domNode.innerHTML; // ('src');
	}
}
QuillDValue.blotName = 'dvalue';
QuillDValue.className = 'd-value';
QuillDValue.tagName = 'span';

Quill.register({
	'formats/dvalue': QuillDValue
});

// --------------------

const alignConfig = {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['left', 'right', 'center', 'justify']
};

let AlignAttribute = new Parchment.Attributor.Attribute('align', 'align', alignConfig);
let AlignClass = new Parchment.Attributor.Class('align', 'ql-align', alignConfig);
let AlignStyle = new Parchment.Attributor.Style('align', 'text-align', alignConfig);

Parchment.register(AlignAttribute);
Parchment.register(AlignClass);
Parchment.register(AlignStyle);


export default quillEditor;
</script>
